const Component = () => import('./OrderDetails');

export { Component };
